function initFloodlight(floodlightUrl) {
  var axel = Math.random() + '';
  var a = axel * 10000000000000;
  var iframe = document.createElement('iframe');
  var oldIframe = document.querySelector('iframe.bap-floodlight-iframe');
  if (oldIframe) {
    oldIframe.remove();
  }
  iframe.setAttribute('src', floodlightUrl + a + '?');
  iframe.setAttribute('width', '1');
  iframe.setAttribute('height', '1');
  iframe.setAttribute('style', 'display:none');
  iframe.setAttribute('class', 'dl-floodlight-iframe');
  iframe.setAttribute('frameborder', '0');
  document.body.appendChild(iframe);
}

module.exports = {
  init: initFloodlight,
};
